<script setup lang="ts">
import type { FieldSize } from '@/components/fields/KTextField.vue';

import KTextField from '@/components/fields/KTextField.vue';
import useDecimalField from '@/composables/useDecimalField';

export interface Props {
  modelValue?: number | null;
  label?: string;
  /** Maximum number of digits before decimal point */
  integerDigits?: number;
  /** Number of decimal places */
  decimals?: number;
  size?: FieldSize;
  readonly?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  label: undefined,
  decimals: 2,
  integerDigits: 5,
  readonly: false,
  disabled: false,
});

const emit = defineEmits<{
  'update:modelValue': [value: (typeof props)['modelValue']];
}>();

const { displayValue, handleInput, handleKeypress } = useDecimalField({
  integerDigits: props.integerDigits,
  decimals: props.decimals,
  modelValue: () => props.modelValue,
  onUpdate: (value) => {
    emit('update:modelValue', value);
  },
});
</script>

<template>
  <KTextField
    v-model="displayValue"
    type="text"
    inputmode="decimal"
    :label="props.label"
    :size="props.size"
    :readonly="props.readonly"
    :disabled="props.disabled"
    data-testid="kNumberDecimalField"
    @input="handleInput"
    @keypress="handleKeypress"
  />
</template>
